const resolveSingleReviewItem = (process, itemId = null) => {
    const items = process && Array.isArray(process.items) ? process.items : []

    if (itemId !== null && typeof itemId !== 'undefined') {
        const requestedItem = items.find(item => item && String(item.id) === String(itemId))

        return requestedItem
            ? { item: requestedItem, error: null }
            : { item: null, error: 'item-not-found' }
    }

    if (items.length === 1) {
        return { item: items[0], error: null }
    }

    if (items.length === 0) {
        return { item: null, error: 'item-missing' }
    }

    return { item: null, error: 'item-selection-required' }
}

export { resolveSingleReviewItem }
